import {
    buildBulkUserJobRequestId,
    getBulkUserJobStatus,
    pollBulkUserJobStatus,
} from './bulk-user-job-poll.utils';

export {
    DEFAULT_POLL_INTERVAL_MS,
    DEFAULT_POLL_MAX_ATTEMPTS,
} from './bulk-user-job-poll.utils';

const BULK_PERMISSION_ENDPOINT = '/api/s/_SID_/user/bulk/v2/permissions';
const REQUEST_ID_SUFFIX = 'bulk-permissions';
const OPERATION_LABEL = 'Bulk permission update';

export function buildBulkPermissionRequestId ({ subscriptionId, userId }) {
    return buildBulkUserJobRequestId({ subscriptionId, userId, suffix: REQUEST_ID_SUFFIX });
}

export function getBulkPermissionStatus (requestId) {
    return getBulkUserJobStatus({ endpoint: BULK_PERMISSION_ENDPOINT, requestId });
}

export function pollBulkPermissionStatus (opts = {}) {
    return pollBulkUserJobStatus({
        endpoint: BULK_PERMISSION_ENDPOINT,
        operationLabel: OPERATION_LABEL,
        ...opts,
    });
}
